import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const bannersUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.home_banners}`;

// Login user function
export const headerBannerServices = async (lang) => {
  try {
    const response = await axios.get(bannersUrl, {
      headers: {
        lang: lang || "de",
      },
    });
    return response; // Return the response containing user and token
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while logging in.";
    throw new Error(errorMessage);
  }
};
